import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';

class MemberSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: true,
            currentSelected: {},
            menuExpanded: false,
            menuElement: null
        };
        this.currentMemberChanged = this.currentMemberChanged.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);

        this.listRef = React.createRef();
    }

    componentDidMount() {
        this.props.getMembersList();
        logUI("MBHWeb.UI.MemberSelector.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps) {
        if (this.props.membersList !== prevProps.membersList || this.props.memberError !== prevProps.memberError) {
            this.setState({ showLoader: false });
            if (this.props.membersList !== prevProps.membersList) {
                if (this.props.membersList && this.props.membersList.length > 0) {
                    this.currentMemberChanged(this.props.membersList.find(member => { return member.MemberNbr === this.props.currentMemberId }) || this.props.membersList[0]);
                } else {
                    this.currentMemberChanged({});
                }
            }
        }
    }

    toggleMenu(e) {
        //if (this.listRef && this.listRef.current === e);
        if (!this.state.menuExpanded) {
            document.addEventListener("mousedown", this.toggleMenu);
        } else {
            document.removeEventListener("mousedown", this.toggleMenu);
        }
        this.setState({ menuExpanded: !this.state.menuExpanded })
    }

    currentMemberChanged(mem) {
        if (this.state.currentSelected.MemberNbr && mem.MemberNbr && this.state.currentSelected.MemberNbr == mem.MemberNbr) return;
        this.setState({ currentSelected: mem }, () => {
            this.props.onChange ? this.props.onChange(this.state.currentSelected) : console.error("Member selection changed but no 'onChange' callback was defined");
        });
    }

    render() {
        return (
            <div className="member-selector-wrapper hp">
                {this.state.showLoader
                    ?
                    <div className="spinner">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                    </div>
                    :
                    <div className="member-selector-mainline">
                        <div className="member-label bold-text">Member:</div>
                        <div className="member-current-selected">
                            {`${this.state.currentSelected.FirstName || ""} ${this.state.currentSelected.LastName || ""}`} 
                            {this.props.membersList && this.props.membersList.length > 1 ? <span className="expand-member-select-arrow icon-arrow-sm-down" onClick={(e) => this.toggleMenu(e)}></span> : ""}
                        </div>

                        <ul ref={this.listRef} className={`member-selector-dropdown-container ${this.state.menuExpanded ? "show-list" : ""}`}>
                            <li className="member-selector-list-item" onClick={(e) => { this.toggleMenu(e) }}> {this.state.currentSelected.FirstName} {this.state.currentSelected.LastName} <span className="expand-member-select-arrow dropdown-item-arrow icon-arrow-sm-down"></span></li>
                            {this.props.membersList ? this.props.membersList.map((mem, key) => {
                                if (mem.MemberNbr !== this.state.currentSelected.MemberNbr) return (
                                    <li className="member-selector-list-item" key={`member-selector-${key}`} onClick={() => { this.currentMemberChanged(mem); }}>
                                        {`${mem.FirstName || ""} ${mem.LastName || ""}`}
                                        {this.state.currentSelected.MemberNbr === mem.MemberNbr ? <span className="expand-member-select-arrow icon-arrow-sm-down"></span> : ""}
                                    </li>
                                )
                            }) : "" }
                        </ul>
                    </div>

                }
            </div>
        );
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.toggleMenu);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        currentMemberId: state.healthPlanServices.currentMemberId,
        membersList: state.healthPlanServices.membersList,
        memberError: state.healthPlanServices.error,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMembersList: () => dispatch({ type: types.HP_GET_MEMBERS_LIST_START })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MemberSelector);
